export enum ExternalResourceType {
  TEXT = "text",
  LINK = "link",
  FACEBOOK = "facebook",
  ATTACHMENT = "attachment",
}
